import { createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../Constant";
import { apiCall } from "../../Services/CommonService";

const initialState = {
  productAllData: null,
  productIdData: null,
  productList: null,
  productList1: null,
  productList2: null,
  productList3: null,
  productFeatureList: null,
  productFeatureListLike: null,
  catagoryName: null,
  filterProduct: [],
  filterList: null,
  filterProduct2: null,
  searchData: null,
  productLoading: false,
};

export const product = createSlice({
  name: "product",
  initialState,
  reducers: {
    getProductAllData: (state, action) => {
      state.productAllData = action.payload;
    },
    getCatagoryName: (state, action) => {
      state.catagoryName = action.payload;
    },
    getProductIdData: (state, action) => {
      state.productIdData = action.payload;
    },
    getProductListData: (state, action) => {
      state.productList = action.payload;
    },
    getProductListData1: (state, action) => {
      state.productList1 = action.payload;
    },
    getProductListData2: (state, action) => {
      state.productList2 = action.payload;
    },
    getProductListData3: (state, action) => {
      state.productList3 = action.payload;
    },
    getProductFeatutreListData: (state, action) => {
      state.productFeatureList = action.payload;
    },
    getProductFeatutreListLikeData: (state, action) => {
      state.productFeatureListLike = action.payload;
    },
    getFilterProductData: (state, action) => {
      state.filterProduct = action.payload;
    },
    getFilterProductData2: (state, action) => {
      state.filterProduct2 = action.payload;
    },
    getFilterListData: (state, action) => {
      state.filterList = action.payload;
    },
    getSearchData: (state, action) => {
      state.searchData = action.payload;
    },
    setProductLoading: (state, action) => {
      state.productLoading = action.payload;
    },
  },
});
export const {
  getProductAllData,
  getProductIdData,
  getCatagoryName,
  getProductListData,
  getProductListData1,
  getProductListData2,
  getProductListData3,
  getProductFeatutreListData,
  getProductFeatutreListLikeData,
  getFilterProductData,
  getFilterListData,
  setProductLoading,
  getSearchData,
  getFilterProductData2,
} = product.actions;

export default product.reducer;

export const getProductAllApi = (params = {}, onDone) => (dispatch) => {
  dispatch(setProductLoading(true));

  try {
    const queryString = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          value !== "" &&
          value !== "null"
        ) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    const onSuccess = (response) => {
      dispatch(getProductAllData(response?.product_data || []));
      dispatch(getFilterProductData2(response));
      dispatch(setProductLoading(false));
      if (onDone) onDone();
    };

    const onFailure = (error) => {
      dispatch(getProductAllData([]));
      dispatch(setProductLoading(false));
      if (onDone) onDone();
    };

    apiCall(
      "GET",
      `${apiUrl.GET_ALL_PRODUCT}${queryString ? `?${queryString}` : ""}`,
      "",
      onSuccess,
      onFailure
    );
  } catch (error) {
    dispatch(setProductLoading(false));
    if (onDone) onDone();
  }
};

export const getProductIdApi = (id, userId) => (dispatch) => {
  dispatch(setProductLoading(true));
  try {
    const onSuccess = (response) => {
      dispatch(getProductIdData(response?.product));
      dispatch(setProductLoading(false));
    };
    const onFailure = (error) => {
      dispatch(setProductLoading(false));
    };
    apiCall(
      "GET",
      `${apiUrl.GET_SINGLE_PRODUCT_ID}/${id}?userId=${userId}`,
      "",
      onSuccess,
      onFailure
    );
  } catch (error) {
    dispatch(setProductLoading(false));
  }
};

export const getProductFeatureList = ({ userId, homeFeature, successAction }) =>
  (dispatch) => {
    dispatch(setProductLoading(true));

    const onSuccess = (response) => {

      console.log("getProductFeatureList response ==> ", response)
      dispatch(successAction(response?.products));
      dispatch(setProductLoading(false));
    };

    const onFailure = () => {
      dispatch(setProductLoading(false));
    };

    try {
      apiCall(
        "GET",
        `${apiUrl.GET_FEATURE_LIST}?HomeFeatures=${homeFeature}&userId=${userId}`,
        "",
        onSuccess,
        onFailure
      );
    } catch (error) {
      dispatch(setProductLoading(false));
    }
  };


export const getFilterListApi = () => (dispatch) => {
  dispatch(setProductLoading(true));
  try {
    const onSuccess = (response) => {
      dispatch(getFilterListData(response?.data));
      dispatch(setProductLoading(false));
    };
    const onFailure = (error) => {
      dispatch(setProductLoading(false));
    };
    apiCall(
      "GET",
      `${apiUrl.GET_FILTERLIST_PRODUCT}`,
      "",
      onSuccess,
      onFailure
    );
  } catch (error) {
    dispatch(setProductLoading(false));
  }
};

// Monotonic ticket for search-as-you-type. Broad queries are much slower than
// precise ones — "be" takes ~17s and returns 91 products, "belgrave" takes ~3s and
// returns 1 — so an early, vaguer request routinely lands AFTER the one the user
// actually meant and overwrites it. Only the newest ticket may write results.
let latestSearchTicket = 0;

export const getSearchProductApi = (query, userId, onSuccessCallback) => (dispatch) => {
  const ticket = ++latestSearchTicket;
  dispatch(setProductLoading(true));
  try {
    const onSuccess = (response) => {
      // A newer search has been issued since this one left — drop it. Without this
      // the slowest reply wins, which is the opposite of what the user wants.
      if (ticket !== latestSearchTicket) return;
      dispatch(getFilterListData(response?.products));
      dispatch(setProductLoading(false));
      // Optional: not every caller wants to be told. It used to be called
      // unconditionally, so a dispatch without one threw inside the fetch.
      if (typeof onSuccessCallback === "function") onSuccessCallback(response);
    };
    const onFailure = (error) => {
      if (ticket !== latestSearchTicket) return;
      dispatch(setProductLoading(false));
    };
    apiCall(
      "GET",
      `${apiUrl.GET_SEARCH_PRODUCT
      }?query=${query}&userId=${userId}&limit=${100}`,
      "",
      onSuccess,
      onFailure
    );
  } catch (error) {
    dispatch(setProductLoading(false));
  }
};
